
export default function(o,label,sublabel,big){

  var labelDiv = $('<div>')
    .css({
      flex: '0 0 auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxHeight: '1.8rem',
      padding: '0 1rem',
      fontSize: o.fontSizeDef.xs,
    })
    .html(label)

  if(big){
    labelDiv.css({
      fontSize: o.fontSizeDef.s,
      marginBottom: '0.1rem',
    })
  }

  var sublabelDiv = $('<div>')
    .css({
      flex: '0 0 auto',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxHeight: '0.9rem',
      padding: '0 1rem',
      fontSize: o.fontSizeDef.xs,
    })
    .html(sublabel)

  var div =
    $('<div>')
    .css({
      zIndex: 1,
      textAlign: 'center',
      lineHeight: '0.9rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
    })
    .append([
      labelDiv,
      sublabelDiv,
    ])

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/gridItemLabel/gridItemLabel.js